import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import StandingsTable from "./StandingsTable";
import MvpStatsTable from "./MvpStatsTable";

const SeasonDetailsModal = ({ open, onClose, season, standings = [], cards = [], userId }) => {
    const handleClose = () => {
        onClose();
    };

    if (!season) return null;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
            aria-labelledby="season-details-dialog-title"
        >
            <DialogTitle
                id="season-details-dialog-title"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pb: 1
                }}
            >
                <Typography variant="h6">
                    Season Details - {season.versusSeasonId}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <StandingsTable data={standings} highlightUserId={userId} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MvpStatsTable data={cards} highlightUserId={userId} />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={handleClose} variant="outlined">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SeasonDetailsModal;
